import Grid from "@mui/material/Grid";
import SoftBox from "components/SoftBox";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import MiniStatisticsCard from "examples/Cards/StatisticsCards/MiniStatisticsCard";
import ReportsBarChart from "examples/Charts/PieChart";
import GradientLineChart from "examples/Charts/BarCharts/VerticalBarChart copy";
import SoftPagination from "components/SoftPagination";
import { useEffect, useState } from "react";
import { baseURL } from "utils/api";
import { useDispatch, useSelector } from "react-redux";
import { Card, Pagination, Stack, Alert } from "@mui/material";
import TableData from "../coupon/data/tabledata";
import Table from "examples/Tables/Table";
import Loading from "components/ApnaLoading";
import NotFound from "components/notFound";
import SoftTypography from "components/SoftTypography";
import SoftInput from "components/SoftInput";
import SoftButton from "components/SoftButton";
import { Download, TableChart, PictureAsPdf } from "@mui/icons-material";
import toast from "react-hot-toast";
import { getLocationData } from 'api/commonSlice';
import { CircularProgress } from '@mui/material';

const LoadingDots = ({ size = 'medium', color = 'inherit' }) => {
	const styles = {
		small: {
			fontSize: '0.875rem',
			minWidth: '16px',
			letterSpacing: '1px',
		},
		medium: {
			fontSize: '1rem',
			minWidth: '20px',
			letterSpacing: '2px',
		},
		large: {
			fontSize: '1.25rem',
			minWidth: '24px',
			letterSpacing: '3px',
		}
	};

	return (
		<span 
			style={{ 
				animation: 'pulse 1.5s infinite',
				display: 'inline-block',
				textAlign: 'center',
				fontWeight: 'bold',
				color: color,
				opacity: 0.8,
				...styles[size],
				transition: 'all 0.3s ease',
				'&:hover': {
					opacity: 1,
				}
			}}
		>
			<span style={{ animation: 'slide 1.5s infinite' }}>.</span>
			<span style={{ animation: 'slide 1.5s infinite 0.2s' }}>.</span>
			<span style={{ animation: 'slide 1.5s infinite 0.4s' }}>.</span>
		</span>
	);
};

function Dashboard() {
	const dispatch = useDispatch();
	const userTheme = useSelector((state) => state.commonSlice.theme);
	const id = localStorage.getItem('id');
	const [dashboardData, setDashboardData] = useState({});
	const [pieChartSelectFilter, setPieChartSelectFilter] = useState('');
	const [pieChartOptions, setPieChartOptions] = useState([]);
	const [selectedFilter, setSelectedFilter] = useState('yearly');
	const filterLocation = useSelector((state) => state.searchSlice?.filterLocation);
	const [loading, setLoading] = useState(false);
	const [searchData, setSearchData] = useState('');
	const [data, setData] = useState([])
	const [page, setPage] = useState(1);
	const [startDate, setStartDate] = useState(null);
	const [endDate, setEndDate] = useState(null);
	const { columns, rows } = data;
	const [totalPage, setTotalPage] = useState(1);
	const [offerType, setOfferType] = useState(null);
	const [gradientLineChartData, setGradientLineChartData] = useState({
		labels: [],
		datasets: [
			{
				label: "Coupons",
				color: "info",
				data: [],
			},
		],
		text: ""
	});
	const [isLoading, setIsLoading] = useState(false);

	useEffect(() => {
		dispatch(getLocationData());
	}, []);



	useEffect(() => {
		// gradientLineChartData.labels &&
		//   setPieChartOptions(gradientLineChartData.labels.map((item) => {
		//     return { _id: item, name: item }
		//   }));
		// if (selectedFilter === 'yearly') {
		//   if (gradientLineChartData.labels.length > 0) {
		//     setPieChartSelectFilter(gradientLineChartData.labels[0]);
		//   }
		// } else {
		//   if (gradientLineChartData.labels.length > 0) {
		//     setPieChartSelectFilter(gradientLineChartData.labels[0]);
		//   }
		// }

	}, [gradientLineChartData]);

	const [pieChartData, setPieChartData] = useState({
		labels: ["BOGO", "Discount"],
		datasets: {
			data: [0, 0],
			backgroundColors: ["info", "primary", "secondary"],
		}
	});

	const filterOptions = [
		{ _id: "yearly", name: "Yearly" },
		{ _id: "monthly", name: "Monthly" },
		{ _id: "weekly", name: "Weekly" },
		{ _id: "daily", name: "Daily" },
	];

	const handleFilterChange = (e) => {
		setSelectedFilter(e.target.value);
	};

	const handleFilterChangePieChart = (e) => {
		setPieChartSelectFilter(e);
	};

	const fetchDashboardData = (ev) => {
		setIsLoading(true);
		fetch(`${baseURL}getDashboardData/${id}?businessId=${ev}`)
			.then(res => res.json())
			.then(data => {
				if (data.success) {
					setDashboardData(data.data);
					setIsLoading(false);
				}
			}).catch(err => {
				setIsLoading(false);
				toast.error(err.message || 'Something went wrong');
			});
	}

	const fetchBarData = (filter, ev) => {
		fetch(`${baseURL}dashBoardBarChartData/${id}?timePeriod=${filter}&businessId=${ev}`)
			.then(res => res.json())
			.then(data => {
				if (data.success) {
					setPieChartOptions(data?.timeValueOptions?.map((item) => {
						return { _id: item, name: item }
					}
					));
					setPieChartSelectFilter(data?.timeValueOptions[0]);
					const labels = data?.data.map((item) => item?.label);
					const datasets = data?.data.map((item) => item?.count);
					setGradientLineChartData({
						labels: labels,
						datasets: [
							{
								label: "Coupons",
								color: "info",
								data: datasets,
							},
						],
						text: data?.data?.text
					});
				}
			}).catch(err => {
				console.log(err);
				toast.error(err.message || 'Something went wrong');
			});
	}


	const fetchPieChartData = (filter, secondFilter, ev) => {
		if (secondFilter) {
			fetch(`${baseURL}dashBoardPieChartData/${id}?businessId=${ev}&timeValue=${secondFilter}&timePeriod=${filter}`)
				.then(res => res.json())
				.then(data => {
					if (data.success) {
						const labels = data?.data.map((item) => item?.label);
						const datasets = data?.data.map((item) => item?.count);
						setPieChartData({
							labels: labels,
							datasets: {
								data: datasets,
								backgroundColors: ["info", "primary", "secondary"],
							}
						});
					}
				}).catch(err => {
					toast.error(err.message || 'Something went wrong');
				});
		}
	}


	useEffect(() => {
		fetchDashboardData(filterLocation)
		fetchBarData(selectedFilter, filterLocation);
		fetchPieChartData(selectedFilter, pieChartSelectFilter, filterLocation);
		if (filterLocation) {
			fetchData(1, offerType, startDate, endDate, searchData, filterLocation);
		}
	}, [filterLocation, selectedFilter]);

	useEffect(() => {
		if (pieChartSelectFilter) {
			fetchPieChartData(selectedFilter, pieChartSelectFilter, filterLocation);

			const currentDate = new Date();
			let newStartDate = null;
			let newEndDate = currentDate;

			if (selectedFilter === 'yearly') {
				newStartDate = new Date(pieChartSelectFilter, 0, 1);
				newEndDate = new Date(pieChartSelectFilter, 11, 31);
			} else if (selectedFilter === 'monthly') {
				const monthIndex = gradientLineChartData.labels.indexOf(pieChartSelectFilter);
				newStartDate = new Date(currentDate.getFullYear(), monthIndex, 1);
				newEndDate = new Date(currentDate.getFullYear(), monthIndex + 1, 0);
			} else if (selectedFilter === 'weekly') {
				const weekIndex = gradientLineChartData.labels.indexOf(pieChartSelectFilter);
				newStartDate = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + (weekIndex * 7)));
				newEndDate = new Date(newStartDate);
				newEndDate.setDate(newEndDate.getDate() + 6);
			} else if (selectedFilter === 'daily') {
				const dayIndex = gradientLineChartData.labels.indexOf(pieChartSelectFilter);
				newStartDate = new Date(currentDate.setDate(currentDate.getDate() - currentDate.getDay() + dayIndex));
				newEndDate = new Date(newStartDate);

			}

			// fetchData(1, offerType, newStartDate.toISOString(), newEndDate.toISOString(), searchData, filterLocation);
			setStartDate(newStartDate);
			setEndDate(newEndDate);
		}
	}, [pieChartSelectFilter]);

	const handlePageChange = (page) => {
		setPage(page);
		fetchData(page, offerType, startDate, endDate, searchData, filterLocation);
	}

	const fetchData = (ev, offerType, startDate, endDate, searchData, filterLocation) => {
		setLoading(true);
		const url = `${baseURL}getRedeemOffers/business/${id}?page=${ev}&searchData=${searchData}&startDate=${startDate}&endDate=${endDate}&businessId=${filterLocation}`;

		fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': `Bearer ${localStorage.getItem('token')}`
			}
		}).then(res => res.json())
			.then(data => {
				if (data.success) {
					setData(TableData({
						data: data?.data,
					}));
					setTotalPage(data?.totalPages)
				};
				setLoading(false);
			}).catch(err => {
				setLoading(false);
				console.log(err);
				toast.error(err.message || 'Something went wrong');
			});
	};

	const handelOnClickPieChart = (ev) => {
		if (ev === 0) {
			fetchData(page, "Buy One Get One", startDate, endDate, searchData, filterLocation);
			setOfferType("Buy One Get One");
		} else {
			fetchData(page, "Percentage OFF", startDate, endDate, searchData, filterLocation);
			setOfferType("Percentage OFF");
		}
	}

	const handleOnClickBarChart = (ev) => {
		const findFilter = gradientLineChartData.labels[ev];
		setPieChartSelectFilter(findFilter);
	}


	const handleSubmit = () => {
		fetchData(1, offerType, new Date(startDate).toISOString(), new Date(endDate).toISOString(), searchData, filterLocation);
	}


	const exportFile = async (ev, offerType, startDate, endDate, searchData, main) => {
		const url = `${baseURL}export/redeemOffers/business/${id}?export=${main}&page=${ev}&searchData=${searchData}
        &offerType=${offerType}&businessId=${filterLocation}&startDate=${startDate}&endDate=${endDate}`

		fetch(url, {
			method: 'GET',
			headers: {
				'Authorization': `Bearer ${localStorage.getItem('token')}`
			}
		}).then(res => res.json())
			.then(data => {
				console.log(data, 'export data')
				if (data.success) {
					if (main == 'pdf') {
						// Convert base64 string back to binary
						const byteCharacters = atob(data.data); // base64 decode
						const byteNumbers = new Array(byteCharacters.length);
						for (let i = 0; i < byteCharacters.length; i++) {
							byteNumbers[i] = byteCharacters.charCodeAt(i);
						}
						const byteArray = new Uint8Array(byteNumbers);

						const blob = new Blob([byteArray], { type: 'application/pdf' });
						const link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.setAttribute('download', 'file.pdf');
						document.body.appendChild(link);
						link.click();
						link.remove();
					} else {
						const blob = new Blob([new Uint8Array(data?.data?.data)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
						const link = document.createElement('a');
						link.href = window.URL.createObjectURL(blob);
						link.setAttribute('download', 'file.xlsx');
						document.body.appendChild(link);
						link.click();
						link.remove();
					}
				} else {
					console.error('Invalid data or download link');
					throw new Error('Invalid data or download link');
				}
			}).catch(err => {
				console.error('Error downloading file:', err);
				toast.error(err.message || 'Something went wrong');
			});
	}

	const onSearchChange = (e) => {
		fetchData(1, offerType, startDate, endDate, e.target.value, filterLocation);
		setSearchData(e.target.value);
	};



	return (
		<DashboardLayout>
			<DashboardNavbar />
			{dashboardData?.isBusinessLive === false && <SoftBox pt={3}>
				<Alert
					severity="info" 
					variant="gradient"
					sx={{ 
						backgroundColor: 'error.light',
						color: '#ffffff',
						'& .MuiAlert-icon': {
							color: '#ffffff',
							display: 'flex',
							alignItems: 'center',
							padding: '8px 0'
						},
						'& .MuiAlert-message': {
							color: '#ffffff',
							display: 'flex',
							alignItems: 'center',
							padding: '8px 0'
						},
						opacity: 0.9,
						boxShadow: 'none'
					}}
				>
					Your business is under review and will be live after verification by team 1ONUS.
				</Alert>
			</SoftBox>}
			<SoftBox py={3}>
				<SoftBox mb={3}>
					<Grid container spacing={2}>
						<Grid item xs={12} sm={6} md={4} lg={2.4}>
							<MiniStatisticsCard
								title={{ text: "Total Customers" }}
								count={isLoading ? <LoadingDots size="large" color="info" /> : dashboardData?.totalUsers || 0}
								icon={{ color: "info", component: "people" }}
							/>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={2.4}>
							<MiniStatisticsCard
								title={{ text: "Returned Customers" }}
								count={isLoading ? <LoadingDots size="large" color="info" /> : dashboardData?.returnedCustomer || 0}
								icon={{ color: "info", component: "hail" }}
								percentage={{
									color: "dark",
									text: isLoading ? "" : (
										<>
											<span style={{ 
												color: parseInt(dashboardData?.percentageOfReturnedCustomer) > 0 
													? "#4caf50" 
													: parseInt(dashboardData?.percentageOfReturnedCustomer) < 0 
														? "#f44336" 
														: "rgb(131, 146, 171)",
												marginLeft: 5,
												fontSize: "12px"
											}}>
												{parseInt(dashboardData?.percentageOfReturnedCustomer) > 0 ? '+' : ''}
												{dashboardData?.percentageOfReturnedCustomer + "%" || "0%"}
											
											</span>
											<span variant="caption" style={{ marginLeft: 4, color: "rgb(131, 146, 171)", fontSize: "11px" }}>returned users</span>
										</>
									)
								}}
							/>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={2.4}>
							<MiniStatisticsCard
								title={{ text: "Total Reviews" }}
								subtitle=""
								count={isLoading ? <LoadingDots size="large" color="info" /> : dashboardData?.totalReviewsCount || 0}
								icon={{ color: "info", component: "tablet_mac" }}
							/>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={2.4}>
							<MiniStatisticsCard
								title={{ text: "Total Views" }}
								subtitle=""
								count={isLoading ? <LoadingDots size="large" color="info" /> : dashboardData?.totalVisit || 0}
								icon={{ color: "info", component: "wysiwyg" }}
							/>
						</Grid>

						<Grid item xs={12} sm={6} md={4} lg={2.4}>
							<MiniStatisticsCard
								title={{ text: "Unique Visitors" }}
								subtitle=""
								count={isLoading ? <LoadingDots size="large" color="info" /> : dashboardData?.distinctRecord || 0}
								icon={{ color: "info", component: "wysiwyg" }}
							/>
						</Grid>
					</Grid>
				</SoftBox>


				<SoftBox mb={3}>
					<Grid container spacing={3}>

						<Grid item xs={12} lg={6}>
							<GradientLineChart
								handleOnClickBarChart={handleOnClickBarChart}
								option={filterOptions}
								handleFilterChange={handleFilterChange}
								selectedFilter={selectedFilter}
								title="Coupons Used"
								description={
									<SoftTypography variant='caption' display="flex" alignItems="center">

										{gradientLineChartData?.text}
									</SoftTypography>
								}
								height="21.5rem"
								chart={gradientLineChartData}
							/>
						</Grid>
						<Grid item xs={12} lg={6}>
							<ReportsBarChart
								handleFilterChangePieChart={handleFilterChangePieChart}
								option={pieChartOptions}
								value={pieChartSelectFilter}
								height="21rem"
								title="Coupons Redeemed"
								handelOnClickPieChart={handelOnClickPieChart}
								description={
									<>
										<strong></strong>
									</>
								}
								chart={pieChartData}
							/>
						</Grid>
					</Grid>
				</SoftBox>
				<SoftBox mb={3}>
					<Card className="glassmorphism-card">
						<SoftBox
							sx={{
								display: 'flex',
								justifyContent: 'space-between',
								alignItems: 'center',
								m: 2
							}}
						>

							<SoftBox width="30%" >
								<SoftInput
									onChange={onSearchChange}
									placeholder="Search here..."

									icon={{ component: "search", direction: "left" }}
								/>
							</SoftBox>

							<SoftBox
								width="65%"
								ml={2}
							>
								<SoftBox sx={{ display: 'flex', gap: 2, }}>

									<SoftInput label="Start Date" type="date" value={startDate}
										onChange={(e) => {
											setStartDate(e.target.value)
										}}

									/>

									<SoftInput label="End Date" type="date" value={endDate}
										onChange={(e) => {
											setEndDate(e.target.value)
										}}

									/>

									<SoftButton
										fullWidth
										variant="gradient"
										color="info"
										sx={{ color: 'white', marginRight: 2 }}
										onClick={handleSubmit}
									>
										Submit
									</SoftButton>
								</SoftBox>

							</SoftBox>

							<SoftBox
								width="40%" display="flex" gap={2} mt={0} alignItems='center' justifyContent='end' >
								<SoftButton 
									variant="contained" 
									style={{ 
										backgroundColor: userTheme === 'dark' ? '#1e1e1e' : '#e8f5e9', 
										color: userTheme === 'dark' ? '#ffffff' : '#2e7d32',
										display: 'flex',
										alignItems: 'center',
										gap: '8px'
									}}
									disabled={rows?.length === 0}
									onClick={() => exportFile(page, offerType, startDate, endDate, searchData, 'excel')}
								>
									<TableChart sx={{ fontSize: 30 }} />
									<SoftTypography variant="button" fontWeight="medium">
										Export Excel
									</SoftTypography>
								</SoftButton>
								<SoftButton 
									variant="contained" 
									style={{ 
										backgroundColor: userTheme === 'dark' ? '#1e1e1e' : '#fff3e0', 
										color: userTheme === 'dark' ? '#ffffff' : '#e65100',
										display: 'flex',
										alignItems: 'center',
										gap: '8px'
									}}
									disabled={rows?.length === 0}
									onClick={() => exportFile(page, offerType, startDate, endDate, searchData, 'pdf')}
								>
									<PictureAsPdf sx={{ fontSize: 30 }} />
									<SoftTypography variant="button" fontWeight="medium">
										Export PDF
									</SoftTypography>
								</SoftButton>
							</SoftBox>
						</SoftBox>
						<SoftBox
							sx={{
								"& .MuiTableRow-root:not(:last-child)": {
									"& td": {
										borderBottom: ({ borders: { borderWidth, borderColor } }) =>
											`${borderWidth[1]} solid ${borderColor}`,
									},
								},
							}}
						>
							{
								loading ? <Loading /> : rows?.length > 0 ? <Table columns={columns} rows={rows} /> : <NotFound />
							}

						</SoftBox>
						{
							rows && rows?.length > 0 &&
							<>
								<Stack spacing={5} m={5} sx={{ display: "flex", alignItems: 'center', justifyContent: "center" }}>
									<Pagination
										onChange={(event, page) => handlePageChange(page)}
										count={totalPage}
										variant="outlined"
										sx={{
											'& .MuiPaginationItem-root': {
												color: 'gray',
												borderColor: "gray"
											},
											'& .Mui-selected': {
												color: '#ffffff',
												borderColor: "#ffffff",
											},
										}}
										shape="rounded"
									/>
								</Stack>

							</>
						}
					</Card>
				</SoftBox>
				<SoftPagination />
			</SoftBox>
			{/* <Footer /> */}
			<style>
				{`
					@keyframes pulse {
						0% { opacity: 0.3; }
						50% { opacity: 1; }
						100% { opacity: 0.3; }
					}
					@keyframes slide {
						0% { transform: translateY(0); }
						50% { transform: translateY(-2px); }
						100% { transform: translateY(0); }
					}
				`}
			</style>
		</DashboardLayout>
	);
}

export default Dashboard;
